import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import { detectMob, getDeviceType } from "../helper";

export default function FormModal(props) {
  const [whoYouAreError, setWhoYouAreError] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [addressError, setAddressError] = useState(false);
  const [pincodeError, setPincodeError] = useState(false);
  const [questionError, setQuestionError] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [stateError, setStateError] = useState(false);
  const [userid, setUserid] = useState("");
  const [userData, setUserData] = useState({});
  const [avtar, setAvtar] = useState("");
  const [hasError, setHasError] = useState(true);
  const [validEmail, setValidEmail] = useState(true);
  const [userDetails, setUserDetails] = useState({
    whoYouAre: "",
    name: "",
    email: "",
    phone: "",
    state: "",
  });
  const [isLoding, setIsLoading] = useState(false);

  useEffect(() => {
    getStateList();
    if (props.userid) {
      getUserDetails(props.userid);
    }
  }, [props.userid]);

  const getStateList = () => {
    setIsLoading(true);
    var myHeaders = new Headers();
    myHeaders.append(
      "Cookie",
      "ADRUM_BT=R%3A0%7Cg%3A10d42d42-3d3f-4263-adaa-208f869413557%7Cn%3Atmp_bjp_fb49d1de-d391-478a-ab5f-c84d7b25602e%7Ci%3A29127%7Cd%3A18"
    );

    var formdata = new FormData();
    formdata.append("action", "getstatelist");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch("https://api.narendramodi.in/survey", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result && result._resultflag == 1) {
          setStateList(result.data);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoading(false);
      });
  };

  function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  }

  const submitHandler = () => {
    setIsLoading(true);
    let numOfError = 0;

    // console.log("userdetails ", userDetails["whoYouAre"].length);
    // return false;
    if (!userDetails["whoYouAre"] || userDetails["whoYouAre"].length == 0) {
      numOfError += 1;
      setWhoYouAreError(true);
      return false;
    } else {
      setWhoYouAreError(false);
    }
    if (!userDetails["name"]) {
      numOfError += 1;
      setNameError(true);
    } else {
      setNameError(false);
    }
    if (!userDetails["email"]) {
      numOfError += 1;
      setEmailError(true);
    } else {
      isEmail(userDetails["email"])
        ? setValidEmail(true)
        : setValidEmail(false);
      setEmailError(false);
      if (!isEmail(userDetails["email"])) {
        return false;
      }
    }
    console.log("userdetails", userDetails["phone"].length);
    console.log("userdetails", userDetails["phone"]);
    if (!userDetails["phone"]) {
      numOfError += 1;
      setPhoneError(true);
    } else {
      if (userDetails["phone"].length != 10) {
        setPhoneError(true);
        return false;
      }
      setPhoneError(false);
    }
    if (!userDetails["state"] || userDetails["state"].length == 0) {
      numOfError += 1;
      setStateError(true);
      return false;
    } else {
      setStateError(false);
    }

    if (numOfError > 1) {
      setHasError(true);
      return false;
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
    // setHasError(false);
    $("body").removeClass("modal-open");

    var formdata = new FormData();
    formdata.append("action", "postsuggestion");
    formdata.append("token", "T0gtBtYh1hACFYAXQg8NS1eCe5W4KAga");
    formdata.append("userid", props.userid ? props.userid : "");
    formdata.append("user_name", userDetails["name"]);
    formdata.append("user_email", userDetails["email"]);
    formdata.append("user_phone", userDetails["phone"]);
    formdata.append("user_avatar", avtar ? avtar : "");
    formdata.append("user_state", userDetails["state"]);
    formdata.append("who_you_are", userDetails["whoYouAre"]);
    formdata.append("user_suggestion", props.suggestion);
    // formdata.append(
    //   "user_avatar",
    //   "https://cdn.narendramodi.in/cmsuploads/0.16750300_1551771109_1551771256313.jpg"
    // );

    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    fetch("https://api.narendramodi.in/apiv2", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        try {
          let obj = {
            platform: getDeviceType(),
          };
          window.gtag("event", "Post event", obj);
        } catch (error) {}
        let data = {
          ...userDetails,
          avatar: avtar,
        };

        console.log("data is ", data);

        props.addUserDetails({ ...data });

        !props.userid &&
          setUserDetails({
            whoYouAre: "",
            name: "",
            email: "",
            phone: "",
            state: "",
          });
        props.changeSuggestionInputValue("");
        if (result && result._resultflag == 1) {
          props.setUserPostedValue(true);
        } else {
          props.setUserPostedValue(false);
        }

        setHasError(true);

        document
          .getElementById("exampleModalCenter")
          .classList.remove("show", "d-block");
        document
          .querySelectorAll(".modal-backdrop")
          .forEach((el) => el.classList.remove("modal-backdrop"));
        setTimeout(() => {
          props.hideModal();
        }, 200);
        setTimeout(() => {
          props.getSuggestionList(props.userid);
        }, 300);
        var link = document.getElementById("sharenowbutton");
        link.click();
        // props.showShareNowPortal();
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoading(false);
      });
  };

  const getUserDetails = async (userid) => {
    setIsLoading(true);
    var myHeaders = new Headers();
    myHeaders.append(
      "Cookie",
      "ADRUM_BT=R%3A0%7Cg%3Addca9e4c-dc71-4302-941b-9eb58a8792fc4%7Cn%3Atmp_bjp_fb49d1de-d391-478a-ab5f-c84d7b25602e%7Ci%3A29127%7Cd%3A32"
    );

    var formdata = new FormData();
    formdata.append("action", "getuserdetail");
    formdata.append("userid", userid);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch("https://api.narendramodi.in/survey", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setAvtar(result.user_avatar);
        setUserData(result);
        let contact = result.user_contact_no;
        contact =
          contact.indexOf("+91") != "-1" ? contact.split("+91")[1] : contact;
        setUserDetails({
          ...userDetails,
          name: result.user_name_display,
          email: result.user_email,
          state: result["state_name"],
          phone: contact.trim(),
          avatar: result.user_avatar,
        });
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoading(false);
      });
  };
  return (
    <div
      className="modal fade"
      id="exampleModalCenter"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content modal_form">
          <div className="modal-header">
            <h5 className="modal-title">Fill the form to proceed.</h5>

            <img
              src="/images/plus.png"
              className="close_modal"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <form>
              <div className="form-row">
                <div className="form-group col-md-12">
                  <label htmlFor="inputState">Who you are?*</label>
                  <select
                    id="inputState"
                    className="form-select"
                    value={userDetails["whoYouAre"]}
                    onChange={(e) => {
                      setUserDetails({
                        ...userDetails,
                        whoYouAre: e.target.value,
                      });
                      e.target.value && setWhoYouAreError(false);
                    }}
                    onBlur={(e) =>
                      e.target.value
                        ? setWhoYouAreError(false)
                        : setWhoYouAreError(true)
                    }
                  >
                    <option value="">Select who you are</option>
                    <option value="parent">Parent</option>
                    <option value="teacher">Teacher</option>
                    <option value="student">Student</option>
                  </select>
                  {whoYouAreError && (
                    <small id="emailHelp" className="form-text text_error">
                      Please select this field to proceed
                    </small>
                  )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-12">
                  <label htmlFor="exampleInputEmail1">Name*</label>
                  <input
                    type="text"
                    value={userDetails["name"]}
                    onChange={(e) => {
                      setUserDetails({ ...userDetails, name: e.target.value });
                      e.target.value && setNameError(false);
                    }}
                    onBlur={(e) =>
                      e.target.value ? setNameError(false) : setNameError(true)
                    }
                    className="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="Your name"
                  />
                  {nameError && (
                    <small id="emailHelp" className="form-text text_error">
                      Please enter your name to proceed
                    </small>
                  )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-12">
                  <label htmlFor="exampleInputEmail1">Email*</label>
                  <input
                    type="email"
                    value={userDetails["email"]}
                    onChange={(e) => {
                      setUserDetails({ ...userDetails, email: e.target.value });
                      e.target.value && setEmailError(false);
                    }}
                    onBlur={(e) =>
                      e.target.value
                        ? setEmailError(false)
                        : setEmailError(true)
                    }
                    className="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="Your email"
                  />
                  {emailError && (
                    <small id="emailHelp" className="form-text text_error">
                      Please enter your Email to proceed
                    </small>
                  )}
                  {!validEmail && (
                    <small id="emailHelp" className="form-text text_error">
                      Please enter valid Email to proceed
                    </small>
                  )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-12">
                  <label htmlFor="exampleInputEmail1">Mobile*</label>
                  <input
                    type="number"
                    className="form-control"
                    value={userDetails["phone"].trim()}
                    onChange={(e) => {
                      setUserDetails({ ...userDetails, phone: e.target.value });
                      e.target.value && setPhoneError(false);
                    }}
                    onBlur={(e) =>
                      e.target.value
                        ? setPhoneError(false)
                        : setPhoneError(true)
                    }
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="Your mobile"
                  />
                  {phoneError && (
                    <small id="emailHelp" className="form-text text_error">
                      Please enter your Mobile Number to proceed
                    </small>
                  )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-12">
                  <label htmlFor="inputState">State*</label>
                  <select
                    id="inputState"
                    className="form-select"
                    value={userDetails["state"]}
                    onChange={(e) => {
                      setUserDetails({ ...userDetails, state: e.target.value });
                      e.target.value && setStateError(false);
                    }}
                    onBlur={(e) =>
                      e.target.value
                        ? setStateError(false)
                        : setStateError(true)
                    }
                  >
                    <option value="">Select state</option>
                    {stateList &&
                      stateList.length > 0 &&
                      stateList.map((state) => {
                        return (
                          <option
                            key={state["statename"]}
                            value={state["statename"]}
                          >
                            {state["statename"]}
                          </option>
                        );
                      })}
                  </select>

                  {stateError && (
                    <small id="emailHelp" className="form-text text_error">
                      Please select this field to proceed
                    </small>
                  )}
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <h6 className="Policy_txt">
              By continuing you agree to our{" "}
              <a
                href={
                  window.location.href.indexOf("appversion") != -1
                    ? "https://www.narendramodi.in/mobile/privacy-policy?ignore.zip"
                    : detectMob() == "mobile"
                    ? "https://www.narendramodi.in/mobile/privacy-policy"
                    : "https://www.narendramodi.in/privacy-policy"
                }
                target="_blank"
              >
                Privacy Policy{" "}
              </a>{" "}
              &{" "}
              <a
                href={
                  window.location.href.indexOf("appversion") != -1
                    ? "https://www.narendramodi.in/mobile/terms-and-conditions?ignore.zip"
                    : detectMob() == "mobile"
                    ? "https://www.narendramodi.in/mobile/terms-and-conditions"
                    : "https://www.narendramodi.in/terms-and-conditions"
                }
                target="_blank"
              >
                Terms of Use
              </a>
            </h6>
            <button
              onClick={() => submitHandler()}
              type="button"
              id="my-link"
              className=" btn_submit"
              //   data-dismiss={!hasError ? "" : "modal"}
            >
              {/* <button
              onClick={() => submitHandler()}
              type="button"
              className=" btn_submit"
            > */}
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
